const NODE10 = {
  NAME: 'RGB-220LR',
  OUTPUT1: {
    NAME: 'NODE9_OUTPUT1_NAME',
    TYPE: 'rgb',
    ICON: 'rgb',
    PARAMETER_ID: 0,
  },
  OUTPUT2: {
    NAME: 'NODE9_OUTPUT2_NAME',
    TYPE: 'colorPwm',
    ICON: 'red',
    PARAMETER_ID: 0,
  },
  OUTPUT3: {
    NAME: 'NODE9_OUTPUT3_NAME',
    TYPE: 'colorPwm',
    ICON: 'green',
    PARAMETER_ID: 0,
  },
  OUTPUT4: {
    NAME: 'NODE9_OUTPUT4_NAME',
    TYPE: 'colorPwm',
    ICON: 'blue',
    PARAMETER_ID: 0,
  },
  HUE: {
    PARAMETER_ID: 0xE130,
  },
  SATURATION: {
    PARAMETER_ID: 0xE131,
  },
  BRIGHTNESS: {
    PARAMETER_ID: 0xE132,
  },
  RANDOM_COLOR: {
    PARAMETER_ID: 0x6030,
  },
  FADE_TIME: {
    PARAMETER_ID: 0xE140,
  },
  ANIMATION_MODE: {
    PARAMETER_ID: 0xE141,
  },
  BRIGHTNESS_COEFFICIENT: {
    PARAMETER_ID: 0xE142,
  },
  RGB_CHANNEL_INDICES: {
    PARAMETER_ID: 0xE143,
  },
  RGB_INIT: {
    PARAMETER_ID: 0xE220,
  },
  TEMPERATURE: {
    NAME: 'NODE7_TEMPERATURE_NAME',
    TYPE: 'internalTemperature',
    ICON: 'temperature',
    PARAMETER_ID: 0x8101,
  },
  NOTIFY_HUB: {
    PARAMETER_ID: 0x6100,
  },
  LORA_RSSI: {
    PARAMETER_ID: 0x8102,
  },
  LORA_SNR: {
    PARAMETER_ID: 0x8103,
  },
}
//TODO: set default instructions
NODE10.DEFAULT_INSTRUCTIONS = [];

export default NODE10;